/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getApplicationVersionSupportedOverrides';

export type GetApplicationVersionSupportedPathParams = NonNullable<
  operations['getApplicationVersionSupported']['parameters']['path']
>;

export type GetApplicationVersionSupportedQueryParams = NonNullable<
  operations['getApplicationVersionSupported']['parameters']['query']
>;

export interface Input extends GetApplicationVersionSupportedPathParams {
  apiVersion?: string;
  query: GetApplicationVersionSupportedQueryParams;
}

export async function getApplicationVersionSupported(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/applications/{applicationKey}/versions', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
